import { Input, Checkbox } from "semantic-ui-react";
import React, { FC, useState } from "react";
import { getDecodeOutputSQSValues, buttonInSegment } from "./utils";
import { SqsConfigContent } from "./SQSConfig";

interface RenameInputProps {
    index: number;
    value: string;
    content: SqsConfigContent;
    setContent: (content: SqsConfigContent) => void;
    withFifo?: boolean;
}

const RenameInput: FC<RenameInputProps> = ({ index, value, content, setContent, withFifo = false }) => {
    const [isFifo, setIsFifo] = useState(value.endsWith(".fifo"));
    const [renameValue, setRenameValue] = useState<string>(value.replace(/\.fifo$/, ""));

    const handleKeyDown = (event: any) => {
        setRenameValue(event.target.value);
    };

    const replaceElements = () => {
        const updatedObject: SqsConfigContent = {};
        if (!value) return {};
        const newValue = isFifo ? `${renameValue}.fifo` : renameValue;

        if (value in content) {
            for (const key in content) {
                updatedObject[key === value ? newValue : key] = content[key];
            }
        } else {
            const replacements = getDecodeOutputSQSValues(value).reduce(
                (obj, key, index) => {
                    obj[key] = getDecodeOutputSQSValues(newValue)[index];
                    return obj;
                },
                {} as { [key: string]: string },
            );

            for (const key in content) {
                updatedObject[key] = content[key].map((element) =>
                    replacements[element] !== undefined ? replacements[element] : element,
                );
            }
        }
        setContent(updatedObject);
    };

    return (
        <div style={{ width: "100%" }}>
            <Input
                value={renameValue}
                onChange={(event) => setRenameValue(event.target.value)}
                onKeyDown={(event: any) => handleKeyDown(event)}
                style={{ width: "100%" }}
            />
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "8px", alignItems: "center" }}>
                {withFifo ? (
                    <Checkbox
                        label="fifo"
                        style={{ marginRight: "10px" }}
                        checked={isFifo}
                        onChange={() => setIsFifo(!isFifo)}
                    />
                ) : (
                    <div></div>
                )}
                <div>
                    {buttonInSegment("check", replaceElements)}
                    {buttonInSegment("cancel", () => setContent(content))}
                </div>
            </div>
        </div>
    );
};

export default RenameInput;
